import axios from 'axios';
// import { DEFAULT_CODE } from '../../components/user/CodeContext';

const useLive = false;

export const liveApiUrl = 'https://events-api.aiescape.io';
export const apiUrl =
  (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') && !useLive
    ? 'http://localhost:80'
    : liveApiUrl;

export const axiosInstance = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
    // 'Escape-Code': DEFAULT_CODE,
  },
});

export default axiosInstance;
